var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("videoTable", {
    attrs: {
      videoType: "WATER_DOWN",
      pageName: "水下视频"
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };